export const Footer = ({ children }: { children?: React.ReactNode }) => {
  return (
    <footer className="bg-primary-900 p-4 border-t border-primary-600">
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 ${children ? 'lg:grid-cols-3' : 'lg:grid-cols-2'} gap-4`}
      >
        <p className="text-sm text-white text-center sm:text-left">
          © 2026 Liquor Store Tech, LLC. All rights reserved
        </p>
        <p
          className={`text-white text-center ${children ? 'lg:justify-self-center' : 'lg:justify-self-end'}`}
        >
          Get in touch –{' '}
          <a
            href="mailto:hello@liquorstore.tech"
            target="_blank"
            rel="noreferrer"
            className="text-white hover:underline underline-offset-2"
          >
            hello@liquorstore.tech
          </a>
        </p>
        {children}
      </div>
    </footer>
  );
};
